import { render, staticRenderFns } from "./SearchContent.vue?vue&type=template&id=26a70024&"
import script from "./SearchContent.vue?vue&type=script&lang=js&"
export * from "./SearchContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports